// extracted by mini-css-extract-plugin
export default {"special":"Special_special__yOi4z","special_body":"Special_special_body__+vKAN","special_footer":"Special_special_footer__aBIWF"};